import { getMinItems } from "../utils";
import { LinkButton } from "@certn/cascadia-react";
import { CascadiaJsonFormContext } from "@certn/forms/src/CascadiaJsonFormContext";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ItemProps } from "./types";

interface Props extends ItemProps {
  buttonText?: string;
}

export function DeleteButton(props: Props) {
  const { isSummaryForPath } = useContext(CascadiaJsonFormContext);
  const { t } = useTranslation();
  const {
    path,
    parentPath,
    index,
    removeItems,
    uischema,
    uischema: { options = {} },
    buttonText = t("Delete"),
  } = props;

  const minItems = getMinItems(props.minItems, uischema);
  const showDeleteButton =
    index >= minItems &&
    (options.allowItemDelete ?? true) &&
    !isSummaryForPath?.(path) &&
    props.enabled !== false;

  if (showDeleteButton) {
    return (
      <LinkButton
        textStyle="form/body-secondary-link"
        textColor="text-weak"
        onPress={removeItems?.(parentPath, [index])}
        testID="remove-item"
      >
        {buttonText}
      </LinkButton>
    );
  }
  return null;
}
